const updateCart = (json, additional) => {
  const cartPopup = document.querySelector('.cart-popup');
  const cartItems = document.querySelector('.cart-items');
  const cartButton = document.querySelector('.cart-button');
  const cartTitle = document.querySelector('.cart-title');
  const mobileCartCountString = document.querySelector(
    '.mobile-cart-button span',
  );
  const mobileCartItems = document.querySelector('.mobile-cart-items');

  const filteredCartItems = json.cartItems.filter((item) =>
    Array.isArray(additional) && additional.every((sauce) => sauce.id !== item.productId),
  );

  if (cartButton && json.cartItems.length) {
    const quantity = json.quantity ? ` (${json.quantity})` : ''
    cartButton.innerHTML = `Корзина${quantity} <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.44275 1.25159C2.33619 1.25135 2.23347 1.26391 2.13585 1.2878C2.00204 0.980584 1.82529 0.704964 1.62426 0.495558C1.28306 0.140138 0.744931 0 0 0V1.25C0.455069 1.25 0.716939 1.3182 0.775736 1.37944C1.00252 1.61567 1.2 2.09566 1.2 2.5L1.20603 2.58839L1.79395 6.87532C0.810213 6.92848 0.0481186 7.72426 0.000737148 8.71903L0 9.375C0.0580927 10.4025 0.817652 11.1928 1.76594 11.249L1.90215 11.2492C2.14904 11.9779 2.81598 12.5 3.6 12.5C4.38373 12.5 5.05047 11.9782 5.29757 11.25H6.70242C6.94952 11.9782 7.61627 12.5 8.4 12.5C9.39411 12.5 10.2 11.6605 10.2 10.625C10.2 9.58946 9.39411 8.75 8.4 8.75C7.61627 8.75 6.94952 9.27175 6.70242 10H5.29757C5.05047 9.27175 4.38373 8.75 3.6 8.75C2.81627 8.75 2.14952 9.27175 1.90242 10H1.8C1.494 9.98087 1.21952 9.69525 1.19892 9.33757L1.2 8.75C1.21618 8.42582 1.48879 8.14185 1.82973 8.12423L3.01421 8.12454L3.0228 8.125H9.07011L9.15867 8.09573C9.6136 7.94535 9.97778 7.58851 10.1502 7.12658L10.4188 6.57242C10.6313 6.1337 10.8437 5.69422 11.0508 5.26487C11.5579 4.21317 11.8769 3.54479 11.9475 3.38066C12.3102 2.53778 11.5754 1.88904 10.8244 1.87522L2.44275 1.25159ZM8.86165 6.875H3.06772C3.0292 6.86384 2.99984 6.82985 2.99409 6.78751L2.40615 2.50046L10.736 3.12183C10.5903 3.43145 10.3253 3.98447 9.97846 4.7038L9.96977 4.72183C9.77177 5.13241 9.55959 5.57128 9.3474 6.00942L9.06453 6.59302L9.03526 6.66389C9.00393 6.75485 8.94169 6.82959 8.86165 6.875ZM8.4 11.25C8.73137 11.25 9 10.9702 9 10.625C9 10.2798 8.73137 10 8.4 10C8.06863 10 7.8 10.2798 7.8 10.625C7.8 10.9702 8.06863 11.25 8.4 11.25ZM4.2 10.625C4.2 10.9702 3.93137 11.25 3.6 11.25C3.26863 11.25 3 10.9702 3 10.625C3 10.2798 3.26863 10 3.6 10C3.93137 10 4.2 10.2798 4.2 10.625Z" fill="white"/></svg>`;
  }

  if (json.cartItems.length && mobileCartItems) {
    mobileCartItems.textContent = json.quantity;

    if (!mobileCartItems.classList.contains('visible')) {
      mobileCartItems.classList.add('visible');
    }
  }

  if (
    !json.cartItems.length &&
    mobileCartItems &&
    mobileCartItems.classList.contains('visible')
  ) {
    mobileCartItems.classList.remove('visible');
  }

  if (cartTitle && json.cartItems.length) {
    const quantity = json.quantity ? ` (${json.quantity})` : ''
    cartTitle.innerHTML = `<strong>Корзина${quantity}</strong>`;
  }

  if (mobileCartCountString && json.cartItems.length) {
    mobileCartCountString.textContent = json.quantity;
  }

  if (cartPopup && filteredCartItems.length > 2) {
    cartPopup.classList.add('with-gradient');
  } else if (cartPopup && cartPopup.classList.contains('with-gradient')) {
    cartPopup.classList.remove('with-gradient');
  }

  if (cartItems) {
    cartItems.innerHTML = '';
    const noImage = cartItems.dataset.noimage;

    const items = filteredCartItems.map((product) => {
      let productImageSrc = noImage;
      let productTitle = `<strong>${product.name}</strong>`;
      let productDescription = product.name;
      let productGift = '';
      let productPrice = '';
      let buttonCount = '';

      if (product.parent && product.parent.image) {
        productImageSrc = product.parent.image;
      } else if (product.image) {
        productImageSrc = product.image;
      }

      if (product.parent) {
        productTitle = `<strong>${product.parent.name}</strong>`;
      }

      if (product.type == 'pizza' && product.isSlice) {
        productDescription = product.name;
      } else if (product.type === 'pizza') {
        productDescription = `${product.measureValue} ${product.measureUnit}`;
      } else if (product.type == 'treasure' || product.type == 'set') {
        productDescription = product.description;
      }

      if (product.giftsCount > 0) {
        productGift = `<div class="gift-block placeholder-text bold visible">Подарок ${product.giftsCount} шт.</div>`;
      }

      if (product.giftsCount !== product.quantity) {
        productPrice = `<div class="price very-small-text bold">${
          (product.totalWithoutDiscount) / 100
        } ₽</div>`;
        buttonCount = `<div class="count-button row">
          <button type="button" class="count-control minus ${
            product.quantity < 2 ? 'disabled' : ''
          }">
            <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 0V2H0V0H12Z" fill="#A3A3A3"/>
            </svg>
          </button>
          <input type="number" class="count-input base-text bold" value="${product.quantity}" />
          <button type="button" class="count-control plus ${
            product.quantity == 99 ? 'disabled' : ''
          }">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 12H5L5 0L7 8.74228e-08L7 12Z" fill="#838383"/>
              <path d="M12 5V7H0V5H12Z" fill="#838383"/>
            </svg>
          </button>
        </div>`;
      }

      return `<div class="popup-cart-item row" id="${product.id}" data-id="${
        product.productId
      }" data-type="${product.type}">
          <button type="button" class="delete-button">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.7338 0.2753C11.5638 0.104877 11.3329 0.00910126 11.0922 0.00910126C10.8514 0.00910126 10.6206 0.104877 10.4505 0.2753L6.00001 4.71672L1.54949 0.266199C1.37945 0.0957752 1.1486 0 0.907851 0C0.667107 0 0.436252 0.0957752 0.266212 0.266199C-0.0887373 0.621148 -0.0887373 1.19453 0.266212 1.54948L4.71673 5.99999L0.266212 10.4505C-0.0887373 10.8055 -0.0887373 11.3788 0.266212 11.7338C0.621161 12.0887 1.19454 12.0887 1.54949 11.7338L6.00001 7.28327L10.4505 11.7338C10.8055 12.0887 11.3789 12.0887 11.7338 11.7338C12.0888 11.3788 12.0888 10.8055 11.7338 10.4505L7.28329 5.99999L11.7338 1.54948C12.0797 1.20363 12.0797 0.621148 11.7338 0.2753Z" fill="#838383"/>
            </svg>
          </button>
          <img src="${productImageSrc}"  class="popup-cart-item-image" alt="${
        product.name
      }" />
          <div class="popup-cart-item-info">
            <div class="product-title very-small-text">
              <strong>${productTitle}</strong>
            </div>
            <div class="price-wrapper row">
              <div class="diameter italic very-small-text">${productDescription}</div>
              ${productPrice}
            </div>
            ${productGift}
            ${buttonCount}
          </div>
        </div>`;
    });

    cartItems.innerHTML = items.join('');
  }
};

export default updateCart;
